query ListSubscriptionsPage($limit: Int, $nextToken: String, $view: String, $search: String) {
  page: StreamToolsListSubscriptionsPage(limit: $limit, nextToken: $nextToken, view: $view, search: $search) {
    items {
      subscriptionId
      channelLogin
      broadcasterUserId
      botUserId
      type
      kind
      status
      createdAt
      revocationReason
      revokedAt
      boundEvents {
        eventId
        name
        status
      }
      canForceUnsubscribe
    }
    nextToken
    counts {
      revoked
      pending
    }
  }
}
